import {getOrganizationSlugFromSubdomain} from '@cohort/merchants/lib/Utils';

export function useOrganizationSlug(): string | null {
  return getOrganizationSlugFromSubdomain();
}
